import React, { ComponentProps, useMemo } from 'react';
import { resizeServingUrl } from '~/utils/image';
import { Image } from './image';

type Props = ComponentProps<typeof Image>;

export const ConnectedImage: React.FC<Props> = ({
  src,
  alt = '',
  htmlWidth,
  ...rest
}) => {
  const proxyUrl = useMemo<Props['src']>(() => {
    if (!src) {
      return src;
    }

    if (typeof htmlWidth === 'number') {
      const servingUrl = resizeServingUrl(src, htmlWidth);

      return servingUrl ?? undefined;
    }

    return src;
  }, [htmlWidth, src]);

  return <Image src={proxyUrl} alt={alt} htmlWidth={htmlWidth} {...rest} />;
};
